import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import './App.css';

function App() {
  useEffect(() => {
    // Force reload and clear cache on mount
    const clearCache = () => {
      try {
        // Clear all storage
        localStorage.clear();
        sessionStorage.clear();
        
        // Clear IndexedDB if available
        if ('indexedDB' in window) {
          indexedDB.databases().then(databases => {
            databases.forEach(db => {
              indexedDB.deleteDatabase(db.name);
            });
          }).catch(console.error);
        }
      } catch (error) {
        console.log('Cache clear error:', error);
      }
    };

    clearCache();

    // Add timestamp to prevent caching
    const timestamp = Date.now();
    document.documentElement.setAttribute('data-timestamp', timestamp);

    // Prevent caching with meta tags
    const metaNoCache = document.createElement('meta');
    metaNoCache.httpEquiv = 'Cache-Control';
    metaNoCache.content = 'no-cache, no-store, must-revalidate';
    document.head.appendChild(metaNoCache);

    // Force reload on visibility change (when tab becomes active)
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // Small delay to ensure proper reload
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App;